<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <br />
      <el-row>
        <el-col :span="24">
          <el-table :data="tableData" style="width: 100%" stripe>
            <el-table-column type="index" width="40" align="center"> </el-table-column>
            <el-table-column prop="sn" label="稿件编号" align="center" width="90"> </el-table-column>
            <el-table-column prop="title" label="稿件标题" min-width="150">
              <template slot-scope="scope">
                <h3>{{ scope.row.title }}</h3>
              </template>
            </el-table-column>

            <el-table-column prop="subjectName" :label="subName" width="90"> </el-table-column>

            <el-table-column prop="authorName" label="作者" width="80"> </el-table-column>

            <el-table-column prop="createTime" align="center" label="投稿时间" width="120">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm") }}
              </template>
            </el-table-column>

            <el-table-column prop="employ_notice_time" align="center" label="完成时间" width="120">
              <template slot-scope="scope">
                {{ scope.row.employNoticeTime | datefmt2("YYYY-MM-DD HH:mm") }}
              </template>
            </el-table-column>

            <el-table-column prop="employ_notice_time" align="center" label="耗时" width="100">
              <template slot-scope="scope">
                {{ scope.row.employNoticeTime | dateDuration(scope.row.createTime, "dh") }}
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" align="center" :width="isCharge ? 400 : 240">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="downNotice(scope.row.id, scope.row.sn, scope.row.title)">下载用稿通知</el-button>
                <el-button size="mini" @click="showProcess(scope.row.id)">查看流程</el-button>
                <el-button v-if="scope.row.invoice2 < 1 && isCharge" size="mini" type="primary" @click="invoiceAdd(scope.row.id)">申请电子发票信息</el-button>
                <el-button v-if="scope.row.invoice2 >= 1 && isCharge" size="mini" type="default" @click="invoicePage">查看申请发票记录</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <el-row style="margin-top: 20px">
        <el-pagination background layout="prev, pager, next" :page-size="10" :total="total" @current-change="pageChange" @prev-click="pagePrev" @next-click="pageNext" style="float: right"> </el-pagination>
      </el-row>
    </div>

    <el-drawer :title="drawerTitle" :visible.sync="drawer" :direction="'rtl'" :size="700" :destroy-on-close="true" :wrapperClosable="false">
      <div style="padding: 0 20px 20px 20px">
        <ArticleProcess v-if="drawerAction == 'process'" ref="ArticleProcess" :articleId="articleId" role="USER"></ArticleProcess>
        <InvoiceAdd v-if="drawerAction == 'invoiceAdd'" :articleId="articleId" @submitSuccess="invoiceAddSuccess" @close="closeDrawer"></InvoiceAdd>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import ArticleProcess from "@/components/ArticleProcess.vue"
import InvoiceAdd from "@/components/InvoiceAdd.vue"
import authorApi from "@/api/author"
import attachApi from "@/api/attach"
import attachUtil from "@/utils/attachUtil"

export default {
  components: { PageHeader, ArticleProcess, InvoiceAdd },
  data() {
    return {
      subName: process.env.VUE_APP_PLATFORM == "dx" ? "栏目" : "科目",
      headLinks: [{ path: "", title: "已录用稿件" }],
      curPage: 1,
      tableData: [],
      total: 0,
      pageSize: 10,

      drawer: false,
      drawerTitle: "",
      drawerAction: "",
      articleId: null,
      isCharge:true,
    }
  },
  mounted() {
    this.isCharge = this.$config.isCharge
    this.loadData()
  },

  methods: {
    //加载数据
    loadData() {
      authorApi.myArticleReceiveList(this.curPage, this.pageSize).then((res) => {
        this.total = res.total
        this.tableData = res.rows
      })
    },

    openDraw(title, action) {
      this.drawerAction = action
      this.drawer = true
      this.drawerTitle = title
    },
    closeDrawer() {
      this.drawer = false
    },
    invoiceAddSuccess() {
      this.closeDrawer()
      this.loadData()
    },

    showProcess(articleId) {
      this.openDraw("查看流程", "process")
      this.articleId = articleId
    },

    invoiceAdd(articleId) {
      this.openDraw("申请电子发票", "invoiceAdd")
      this.articleId = articleId
    },

    invoicePage() {
      this.$router.push("/article/myInvoiceList")
    },

    pageChange(current) {
      this.curPage = current
      this.loadData()
    },
    pagePrev(current) {
      this.curPage = current
    },
    pageNext(current) {
      this.curPage = current
    },

    downNotice(articleId, sn, title) {
      attachApi.downNotice(articleId, sn, title).then((res) => {
        if (res.type != "application/octet-stream") {
          this.$alert("下载失败，用稿通知文件不存在!", "错误", {
            confirmButtonText: "确定",
          })
        } else {
          attachUtil.download(res, sn + "-" + title + "-用稿通知.pdf")
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
